<template>
  <TButtonGroup>
    <TGroupButton
      data="line-through"
      tooltip="Strike through"
      small
      toggle
      :active="isStrikeActive"
      :inverse="inverse"
      @button-clicked="toggleStrike"
    >
      <font-awesome-icon :icon="['fas', 'strikethrough']" />
    </TGroupButton>
  </TButtonGroup>
</template>

<script setup lang="ts">
import { expandSelectionToWord, getActiveMarks } from "../_internal/cutomExtensions";
import { TButtonGroup, TGroupButton } from "@topol/twig-ui";
import { Editor } from "@tiptap/core";
import { computed } from "vue";

const props = defineProps<{
  editor: Editor;
  inverse?: boolean;
}>();

const isStrikeActive = computed(() => {
  if (!props.editor) return false;

  // Check stored marks first (for empty paragraphs)
  const marks = getActiveMarks(props.editor);
  const hasStrikeMark = marks.some((mark) => mark.type.name === "strike");
  if (hasStrikeMark) return true;

  // Fallback to editor.isActive
  return props.editor.isActive("strike");
});

function toggleStrike() {
  if (!props.editor) return;
  expandSelectionToWord(props.editor);
  props.editor.chain().focus().toggleStrike().run();
}
</script>
